import { message, Popover, List, Avatar, Spin, Menu, Dropdown } from 'antd'
import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import IntlMessages from '../util/IntlMessages'
import { Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { StandardInvoice } from './StandardInvoice'
import { StandardThermalReceipt } from './StandardThermalReceipt'
import { ZeeReport } from './ZeeReport'
import { useSelector, useDispatch } from 'react-redux'
import {
  FileTextOutlined,
  PrinterFilled,
  DownloadOutlined,
  EyeOutlined
} from '@ant-design/icons'
import { PrintLastSummary } from '../../src/routes/Sell/OpenClose/PrintSummary'
import { SALE_REG_REPORT_PRINT } from '../constants/StoreSetting'
import {
  getDecryptID,
  isEmptyObject,
  loadSendPrint,
  loadShowPrintOpenClose,
  onPrintConfigNew
} from '../appRedux/actions'
import JsonToExcel from '../components/JsonToExcel'
import ds from '../Services/DataServices'
import moment from 'moment'
import { loadJsonToExcelData } from '../appRedux/actions/Reports'
import { getPrintStringForReceipt } from './PrintString'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import { env } from '../env'
import ChoosePrinter from './SellScreen/ChoosePrinter'
import { OpenClosePrint } from './OpenClosePrint'
import {
  ShowSaleDate,
  ShowSaleRefID,
  ShowSaleTax,
  ShowSaleTotalAmount,
  ShowSaleTotalTax
} from '../constants/GeneralSetting'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'
import TabletPrinters from './SellScreen/TabletPrinters'
const {
  REACT_APP_LOCALIP_PRINT_HTTP,
  REACT_APP_PROXY_SERVER,
  TS_COOKIE_BASE_DOMAIN
} = env

const OpenCloseDefData = [
  {
    id: SALE_REG_REPORT_PRINT.CURR_OPEN,
    name: 'Current X Report' // Current Opened
  }
  // {
  //   id: SALE_REG_REPORT_PRINT.TODAY,
  //   name: 'Today X Report' // Today
  // }
  // {
  //   id: SALE_REG_REPORT_PRINT.PAST_ONE,
  //   name: "Previous 1 opened"
  // },
  // {
  //   id: SALE_REG_REPORT_PRINT.PAST_TWO,
  //   name: "Previous 2 openings"
  // },
]

const f = [
  { refID: 1, amount: 28, tax: 50 },
  { refID: 2, amount: 32, tax: 45 },
  { refID: 3, amount: 45, tax: 55 }
]

const expires_in = 18

const InfoToPrint = props => {
  const {
    outletName,
    registerName,
    isCurrentOpened,
    regSummaryCashID,
    allowPrintNote,
    allowDiscountShow,
    showExtraPrinters,
    customPrint,
    printExtraData,
    isOpen,
    _regID,
    allowPrint
  } = props
  const role = props.role ? props.role : '0'
  const data = props.data ? props.data : false
  const dataLastSummary = props.dataLastSummary ? props.dataLastSummary : false
  const dispatch = useDispatch()
  const componentRef = useRef()
  const componentThermalRef = useRef()
  const componentInvoiceRef = useRef()
  const componentZReporteRef = useRef()
  const componentOpenCloseRef = useRef()
  const history = useHistory()

  const getReduxTemplatedData = useSelector(
    ({ Setup }) => Setup.receiptTemplatesData
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const decimal = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const isSendPrint = useSelector(({ MainSale }) => MainSale.isSendPrint)
  // const getDataToPrint = useSelector(({ MainSale }) => MainSale.getDataToPrint)
  const getAmountDiff = useSelector(({ MainSale }) => MainSale.getAmountDiff)

  const [getTemplateData, setTemplateData] = React.useState({})
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getSelectedReg, setSelectedReg] = React.useState('')
  const [getRegID, setRegID] = React.useState('')
  const [getOutletID, setOutletID] = React.useState('')
  const [getOpenCloseLoader, setOpenCloseLoader] = React.useState(false)
  const [getOpenCloseData, setOpenCloseData] = React.useState({})
  const [getCurrData, setCurrData] = React.useState({
    currencyCode: 'EUR',
    currencySymbol: '€'
  })
  const [getRegName, setRegName] = React.useState('')
  const [getOutletName, setOutletName] = React.useState('')
  const [cookies, setCookie, removeCookie] = useCookies([
    'printHTML',
    'ip',
    'port'
  ])
  const [buttonLoading, setButtonLoading] = React.useState(false)
  const [showPrinters, setShowPrinters] = React.useState(false)
  const [showRefID, setShowRefID] = React.useState(false)
  const [showSaleTax, setShowSaleTax] = React.useState(false)
  const [showSaleDate, setShowSaleDate] = React.useState(false)
  const [showTotalAmount, setShowTotalAmount] = React.useState(false)
  const [showTotalTax, setShowTotalTax] = React.useState(false)

  //for selected outlet & register, commmon Data
  React.useEffect(() => {
    if (
      getReduxSelectedStoreOutlets.outlet &&
      getReduxSelectedOutletReg.register
    ) {
      setSelectedOutlet(getReduxSelectedStoreOutlets.outlet)
      setSelectedReg(getReduxSelectedOutletReg.register)
      setOutletID(
        getReduxSelectedStoreOutlets.id ? getReduxSelectedStoreOutlets.id : ''
      )
      setRegID(getReduxSelectedOutletReg.id ? getReduxSelectedOutletReg.id : '')
    } else {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      let selectedLocalReg = localStorage.getItem('selectedReg')

      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        setSelectedOutlet(
          getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : selectedLocalOut.outlet
        )
        setOutletID(selectedLocalOut.id)
      }
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg)
        setSelectedReg(
          getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : selectedLocalReg.register
        )
        setRegID(selectedLocalReg.id)
      }
    }
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (
      mounted &&
      customPrint &&
      printExtraData &&
      !isEmptyObject(printExtraData)
    ) {
      dispatch(loadShowPrintOpenClose(false))
      if (showExtraPrinters) {
        setShowPrinters(true)
      } else {
        handleOpenClosePrint()
      }
    }
    return () => {
      mounted = false
    }
  }, [customPrint])

  React.useEffect(() => {
    //for common data -> store currency
    let commonData = getReduxCommonSetting
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig
    ) {
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrData(currencyData)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.generalConfigs &&
        commonData.storeCommonConfigs.storeConfig.generalConfigs.length > 0
      ) {
        commonData.storeCommonConfigs.storeConfig.generalConfigs.map(dd => {
          if (dd.key == ShowSaleRefID) {
            setShowRefID(dd.value && dd.value == '1' ? true : false)
          } else if (dd.key == ShowSaleTax) {
            setShowSaleTax(dd.value && dd.value == '1' ? true : false)
          } else if (dd.key == ShowSaleDate) {
            setShowSaleDate(dd.value && dd.value == '1' ? true : false)
          } else if (dd.key == ShowSaleTotalAmount) {
            setShowTotalAmount(dd.value && dd.value == '1' ? true : false)
          } else if (dd.key == ShowSaleTotalTax) {
            setShowTotalTax(dd.value && dd.value == '1' ? true : false)
          }
        })
      }
    }
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    const mountRole = role == 'AutoPrintSale' || role == 'OfflineStatus'
    if (mounted && isSendPrint && mountRole) {
      performSendPrint()
      dispatch(loadSendPrint(false))
    }
    return () => {
      mounted = false
    }
  }, [isSendPrint])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  })

  const handleThermalPrint = useReactToPrint({
    content: () => componentThermalRef.current
  })

  const handleInvoicePrint = useReactToPrint({
    content: () => componentThermalRef.current // componentInvoiceRef.current
  })

  const handleZeePrint = useReactToPrint({
    content: () => componentZReporteRef.current
  })

  const handleOpenClosePrint = useReactToPrint({
    content: () => componentOpenCloseRef.current
  })

  function performSendPrint () {
    if (checkIsWeb().exist) {
      printReceiptTemplate(true)
    } else {
      const fa =
        localStorage.getItem('printConfig') ||
        localStorage.getItem('li_printrz')
      const isExtraPrinterExist =
        localStorage.getItem('extraPrints') &&
        localStorage.getItem('extraPrints') == '1'
      if (fa && fa != '0' && role != 'OfflineStatus') {
        onPrintConfigNew(
          getReduxTemplatedData,
          data,
          outletName,
          registerName,
          allowPrintNote,
          allowDiscountShow,
          getCurrData
        )
      } else if (isExtraPrinterExist) {
        setShowPrinters(true)
      }
    }
  }

  function printReceiptTemplate (isDefault, value) {
    if (isDefault) {
      let storedData =
        getReduxTemplatedData && getReduxTemplatedData.length > 0
          ? getReduxTemplatedData.filter(e => e.isDefault == true)
          : []
      let defaultData = storedData.length > 0 ? storedData[0] : {}
      setTemplateData(defaultData)
      if (defaultData && defaultData.templateStyleID == 1) {
        // handleThermalPrint();
        setTimeout(() => {
          handleThermalPrint()
        }, 1000) //small fraction of delay to load data
      } else {
        // handleInvoicePrint();
        setTimeout(() => {
          handleInvoicePrint()
        }, 1000)
      }
    } else {
      setTemplateData(value)
      if (value.templateStyleID == 1) {
        // handleThermalPrint();
        setTimeout(() => {
          handleThermalPrint()
        }, 1000) //small fraction of delay to load data
      } else {
        // handleInvoicePrint();
        setTimeout(() => {
          handleInvoicePrint()
        }, 1000)
      }
    }
  }

  const OtherReceiptTemplates = () => {
    return (
      <>
        {getReduxTemplatedData && getReduxTemplatedData.length > 0 ? (
          <>
            <List
              itemLayout='horizontal'
              dataSource={getReduxTemplatedData}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<FileTextOutlined />}
                    title={
                      <a onClick={() => printReceiptTemplate(false, item)}>
                        {item.templateName + 'ss'}
                      </a>
                    }
                  />
                </List.Item>
              )}
            />
          </>
        ) : (
          <>
            <h3>Something Went Wrong</h3>
            <h4>Please Try Again Later...</h4>
          </>
        )}
      </>
    )
  }

  function printOpenCloseReport (id, isPrint) {
    if (id) {
      const cashManageID =
        role == 'OpenClose'
          ? localStorage.getItem('cashManageID')
          : role == 'RegSummary'
          ? regSummaryCashID
          : ''
      const body = {
        RegID: _regID ? _regID : getRegID,
        OutletID: getOutletID,
        CashRegPayID:
          id == SALE_REG_REPORT_PRINT.CURR_OPEN && cashManageID
            ? cashManageID
            : '',
        Type: id
      }
      setOpenCloseLoader(true)
      getSaleRegRecords(body, isPrint)
    }
  }

  async function getSaleRegRecords (body, isPrint) {
    const cashInOutService = ds.getSaleReportPrintService(body)
    await cashInOutService
      .then(res => {
        setOpenCloseLoader(false)
        if (res && !isEmptyObject(res)) {
          let data = {
            sales: res.sales && res.sales.length > 0 ? res.sales : [],
            totalAmount: res.totalAmount,
            totalTax: res.totalTax,
            totalVoid: res.totalVoid,
            outletName: getSelectedOutlet,
            registerName: getSelectedReg,
            totalPayments: res.totalPayments,
            totalAmountPayList: res.totalAmountPayList
          }
          if (isPrint) {
            setOpenCloseData(data)
            if (showExtraPrinters) {
              setShowPrinters(true)
            } else {
              handleZeePrint()
            }
          }
          if (!isPrint) {
            let downloadData =
              res.sales && res.sales.length > 0 ? res.sales : []
            downloadData =
              downloadData &&
              downloadData.map(x => {
                return {
                  Date: moment(x.date).format('DD/MM/YYYY hh:mm:ss'),
                  ReferenceID: getDecryptID(x.refID),
                  Amount: x.amount,
                  Tax: x.tax
                }
              })
            // setOpenCloseDownloadData(downloadData);
            dispatch(loadJsonToExcelData(downloadData))
          }

          // setTimeout(() => {
          // }, 600); //small fraction of delay to load data
        }
      })
      .catch(e => {
        setOpenCloseLoader(false)
      })
  }

  const ReportForOpenClose = () => {
    return (
      <>
        <Spin
          tip={<IntlMessages id='common.resource.loading' />}
          spinning={getOpenCloseLoader}
          size='large'
        >
          {isCurrentOpened
            ? OpenCloseDefData &&
              OpenCloseDefData.length > 0 &&
              OpenCloseDefData.map((e, i) => {
                return (
                  <Button
                    key={i}
                    onClick={() => printOpenCloseReport(e.id, true)}
                    type='primary'
                  >
                    {e.name}
                  </Button>
                )
              })
            : OpenCloseDefData &&
              OpenCloseDefData.length > 0 &&
              OpenCloseDefData.filter(
                a => a.id != SALE_REG_REPORT_PRINT.CURR_OPEN
              ).map((e, i) => {
                return (
                  <Button
                    key={i}
                    onClick={() => printOpenCloseReport(e.id, true)}
                  >
                    {e.name}
                  </Button>
                )
              })}

          {/* <Button
            key={3}
            onClick={() =>
              printOpenCloseReport(SALE_REG_REPORT_PRINT.CURR_OPEN, false)
            }
          >
            <IntlMessages id='sell.openclose.downloadcurrentxreport' />
          </Button>
          <Button
            key={4}
            onClick={() =>
              printOpenCloseReport(SALE_REG_REPORT_PRINT.TODAY, false)
            }
          >
            <IntlMessages id='sell.openclose.downloadtodayxreport' />
          </Button> */}
        </Spin>
      </>
    )
  }

  const zReportContent = (
    <Menu>
      <Menu.Item
        key={0}
        onClick={() => {
          printOpenCloseReport(SALE_REG_REPORT_PRINT.CURR_OPEN, true)
        }}
      >
        <p>
          <span>
            <PrinterFilled className='dk-btn-icon-align' />
          </span>
          {`Print ${isOpen == '1' ? 'X' : 'Z'} Report`}
        </p>
      </Menu.Item>
      <Menu.Item
        key={1}
        onClick={() => {
          printOpenCloseReport(SALE_REG_REPORT_PRINT.CURR_OPEN, false)
        }}
      >
        <p>
          <span>
            <DownloadOutlined className='dk-btn-icon-align' />{' '}
          </span>{' '}
          {`Download ${isOpen == '1' ? 'X' : 'Z'} Report`}
        </p>
      </Menu.Item>
    </Menu>
  )

  function onPrintConfig () {
    // const localIpPort = localStorage.getItem('printConfig')
    //   ? JSON.parse(localStorage.getItem('printConfig'))
    //   : false
    // let ip = false
    // let port = false
    // let hheader = ''
    // let ffooter = ''
    // let subtitle1 = ''
    // let subtitle2 = ''
    // let showDate = false
    // let showOutlet = false
    // let showRegister = false
    // let showServedBy = false
    // if (localIpPort) {
    //   ip = localIpPort.ip ? localIpPort.ip : false
    //   port = localIpPort.port ? localIpPort.port : false
    //   hheader = localIpPort.header ? localIpPort.header : ''
    //   ffooter = localIpPort.footer ? localIpPort.footer : ''
    //   subtitle1 = localIpPort.subtitle1 ? localIpPort.subtitle1 : false
    //   subtitle2 = localIpPort.subtitle2 ? localIpPort.subtitle2 : false
    //   showDate = localIpPort.showDatetime ? true : false
    //   showOutlet = localIpPort.showOutlet ? true : false
    //   showRegister = localIpPort.showRegister ? true : false
    //   showServedBy = localIpPort.showServedBy ? true : false
    // }
    // if (ip && port) {
    //   let expires = new Date()
    //   expires.setTime(expires.getTime() + expires_in * 1000)
    //   // localStorage.setItem('eerrqqqwww', JSON.stringify(data))
    //   //JSON.stringify(data ? data : {})
    //   let dataPrint = data
    //   dataPrint.outletName = outletName
    //   dataPrint.mainRegister = registerName
    //   dataPrint.hheader = hheader
    //   dataPrint.ffooter = ffooter
    //   dataPrint.subtitle1 = subtitle1
    //   dataPrint.subtitle2 = subtitle2
    //   dataPrint.showDate = showDate
    //   dataPrint.showOutlet = showOutlet
    //   dataPrint.showRegister = showRegister
    //   dataPrint.showServedBy = showServedBy
    //   const recieptHTML = getPrintStringForReceipt(
    //     dataPrint,
    //     getCurrData.currencyCode,
    //     decimal
    //   )
    //   //console.log('receitp asdasd', recieptHTML)
    //   setCookie('ip', ip, {
    //     domain: TS_COOKIE_BASE_DOMAIN,
    //     path: '/'
    //     // expires
    //   })
    //   setCookie('port', port, {
    //     domain: TS_COOKIE_BASE_DOMAIN,
    //     path: '/'
    //     // expires
    //   })
    //   const excryptHTML = btoa(recieptHTML)
    //   setCookie('printHTML', excryptHTML, {
    //     domain: TS_COOKIE_BASE_DOMAIN,
    //     path: '/'
    //     // ,expires
    //   })
    //   setButtonLoading(false)
    //   window.open(REACT_APP_PROXY_SERVER) // REACT_APP_PROXY_SERVER
    // }
  }

  function onPrintClick (da, ignoreConfigs) {
    setButtonLoading(true)
    setTimeout(() => {
      setButtonLoading(false)
    }, 3000)
    if (data) {
      const fa = localStorage.getItem('printConfig')
      if (!ignoreConfigs && fa && fa != '0') {
        onPrintConfig()
      } else printReceiptTemplate(da)
    } else message.warn('Try Again Later...')
  }

  function onPrintClickCallBack (da) {
    setButtonLoading(true)
    setTimeout(() => {
      setButtonLoading(false)
    }, 3000)
    if (data) {
      printReceiptTemplate(da)
    } else message.warn('Try Again Later...')
  }

  function onPrinterModalHide () {
    setShowPrinters(false)
  }

  function callBackDefault (type) {
    if (type == 1) {
      onPrintClickCallBack(true)
    } else if (type == 2) {
      handleZeePrint()
    } else if (type == 3) {
      handleOpenClosePrint()
    }
  }

  const SwitchLayouts = () => {
    switch (role) {
      case 'LastSummary':
        return (
          <>
            <div style={{ display: 'none' }}>
              <PrintLastSummary
                ref={componentRef}
                data={data}
                currData={getCurrData}
                dataLastSummary={dataLastSummary}
              />
            </div>
            <Button
              style={{
                cursor: data ? 'pointer' : 'wait',
                backgroundColor: data ? '' : 'rgb(229, 234, 237)',
                borderColor: data ? '' : 'rgb(229, 234, 237)'
              }}
              className='dk-btn-print-receipt  dk-wd-auto dk-hgt-50'
              type='primary'
              onClick={
                data && data.outletRegister
                  ? handlePrint
                  : () => message.warn('Try Again Later...')
              }
              size='large'
              //   disabled={data ? false : true}
            >
              <IntlMessages id='sell.openclose.printlast' />
            </Button>
          </>
        )
      case 'SaleListingPrint':
        return (
          <>
            <div style={{ display: 'none' }}>
              <StandardInvoice
                ref={componentInvoiceRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
              />
              <StandardThermalReceipt
                ref={componentThermalRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
              />
            </div>
            <Button
              type='primary'
              className='dk-btn-expand-print-receipt  dk-wd-auto dk-hgt-50 edit-text-btn'
              onClick={() => {
                if (showExtraPrinters && !checkIsWeb().exist) {
                  setShowPrinters(true)
                } else {
                  onPrintClick(true, true)
                }
              }}
              loading={buttonLoading}
              icon={<PrinterFilled className='dk-btn-icon-align' />}
              // disabled={!checkIsWeb().exist}
            >
              <IntlMessages id='sell.thermalprint.printreceipt' />
            </Button>
          </>
        )
      case 'ReceiptTemplates':
        return (
          <>
            <div style={{ display: 'none' }}>
              <StandardInvoice
                ref={componentInvoiceRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
              />
              <StandardThermalReceipt
                ref={componentThermalRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
              />
            </div>
            {checkIsWeb().exist && (
              <Button
                type='primary'
                className='dk-btn-print-receipt dk-wd-auto dk-hgt-50 mt-2 mb-3'
                onClick={() => onPrintClick(true, true)}
              >
                <PrinterFilled
                  style={{ marginRight: 5, marginTop: 5, marginBottom: 5 }}
                />
                <IntlMessages id='sell.thermalprint.print' />
              </Button>
            )}
            {!checkIsWeb().exist &&
              localStorage.getItem('extraPrints') &&
              localStorage.getItem('extraPrints') == '1' && (
                <Button
                  className='dk-btn-print-receipt dk-wd-auto dk-hgt-50 dk-mt20'
                  type='primary'
                  onClick={() => setShowPrinters(true)}
                  // disabled={!checkIsWeb().exist}
                >
                  <PrinterFilled
                    style={{ marginRight: 5, marginTop: 5, marginBottom: 5 }}
                  />
                  {/* <IntlMessages id='sell.thermalprint.othertprint' /> */}
                  <IntlMessages id='sell.thermalprint.print' />
                </Button>
              )}
          </>
        )
      case 'OpenClose':
        return (
          <>
            <div style={{ display: 'none' }}>
              <ZeeReport
                ref={componentZReporteRef}
                data={getOpenCloseData}
                currData={getCurrData}
                decimal={decimal}
                showRefID={showRefID}
                showSaleTax={showSaleTax}
                showSaleDate={showSaleDate}
                showTotalAmount={showTotalAmount}
                showTotalTax={showTotalTax}
              />
              <JsonToExcel
                title={'X Report'}
                // data={getOpenCloseDownloadData}
                //fileName={`Z Report--Outlet(${getOutletName})-Register(${getRegName})`}
                fileName={'X Report'}
              />
            </div>
            {isCurrentOpened && (
              <Popover
                content={<ReportForOpenClose />}
                placement='leftTop'
                // title={
                //   <h3>
                //     <strong>
                //       <IntlMessages id="setup.outletlisting.mainOutlet.recepttemplts" />
                //     </strong>
                //   </h3>
                // }
                trigger='click'
              >
                <Button
                  loading={getOpenCloseLoader}
                  className='PrintXReport'
                  type='primary'
                  // disabled={!checkIsWeb().exist}
                >
                  <PrinterFilled />
                  Print X Report
                </Button>
              </Popover>
            )}
          </>
        )
      case 'RegSummary':
        return (
          <>
            <div style={{ display: 'none' }}>
              <ZeeReport
                ref={componentZReporteRef}
                data={getOpenCloseData}
                currData={getCurrData}
                decimal={decimal}
                showRefID={showRefID}
                showSaleTax={showSaleTax}
                showSaleDate={showSaleDate}
                showTotalAmount={showTotalAmount}
                showTotalTax={showTotalTax}
              />
              <JsonToExcel
                title={`Download ${isOpen == '1' ? 'X' : 'Z'} Report`}
                // data={getOpenCloseDownloadData}
                //fileName={`Z Report--Outlet(${getOutletName})-Register(${getRegName})`}
                fileName={`${isOpen == '1' ? 'X' : 'Z'} Report`}
              />
            </div>

            {checkIsWeb().exist ? (
              <Dropdown
                overlay={zReportContent}
                placement='bottomLeft'
                // trigger="click"
              >
                <Button
                  className='mr-3'
                  type='primary'
                  size='large'
                  loading={getOpenCloseLoader}
                  // icon={<PrinterFilled className="dk-btn-icon-align" />}
                >
                  {isOpen == '1' ? 'X Report' : 'Z Report'}
                </Button>
              </Dropdown>
            ) : (
              <Button
                onClick={() => {
                  printOpenCloseReport(SALE_REG_REPORT_PRINT.CURR_OPEN, true)
                }}
                className='mr-3'
                type='primary'
                size='large'
                loading={getOpenCloseLoader}
                // icon={<PrinterFilled className="dk-btn-icon-align" />}
              >
                {isOpen == '1' ? 'X Report' : 'Z Report'}
              </Button>
            )}
          </>
        )
      case 'OPENCLOSE_PRINT':
        return (
          <div style={{ display: 'none' }}>
            <OpenClosePrint
              ref={componentOpenCloseRef}
              data={printExtraData}
              currData={getCurrData}
              decimal={decimal}
              storeInfo={getReduxStoreInfo}
            />
          </div>
        )
      case 'OfflineStatus':
        return (
          <>
            <div style={{ display: 'none' }}>
              <StandardInvoice
                ref={componentInvoiceRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
                allowPrintNote={allowPrintNote}
              />
              <StandardThermalReceipt
                ref={componentThermalRef}
                data={data}
                templateData={getTemplateData}
                currData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                getIsTaxExclusive={getIsTaxExclusive}
                decimal={decimal}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
              />
            </div>
            <EyeOutlined
              style={{ color: '#05314a', fontSize: 16, cursor: 'pointer' }}
              onClick={() => {
                dispatch(loadSendPrint(true))
                // onPrintClick(true, true)
              }}
            />
          </>
        )
      case 'AutoPrintSale':
        return (
          <>
            <div style={{ display: 'none' }}>
              {checkIsWeb().exist && allowPrint && (
                <>
                  <StandardInvoice
                    ref={componentInvoiceRef}
                    data={data}
                    templateData={getTemplateData}
                    currData={getCurrData}
                    outletName={outletName}
                    registerName={registerName}
                    amountPay={getAmountDiff}
                    getIsTaxExclusive={getIsTaxExclusive}
                    allowPrintNote={allowPrintNote}
                    allowDiscountShow={allowDiscountShow}
                  />
                  <StandardThermalReceipt
                    ref={componentThermalRef}
                    data={data}
                    templateData={getTemplateData}
                    currData={getCurrData}
                    outletName={outletName}
                    registerName={registerName}
                    amountPay={getAmountDiff}
                    getIsTaxExclusive={getIsTaxExclusive}
                    allowPrintNote={allowPrintNote}
                    allowDiscountShow={allowDiscountShow}
                  />
                </>
              )}
            </div>
          </>
        )

      default:
        return (
          <>
            <Button
              style={{ float: 'inherit' }}
              className='custom-promoadd-edit2'
              type='primary'
              onClick={() => message.info('Please Try Again Later')}
            >
              <IntlMessages id='sell.openclose.printdefault' />
            </Button>
          </>
        )
    }
  }

  return (
    <div>
      {role != '0' && (
        <>
          {/* <ChoosePrinter
            visible={showPrinters}
            hide={onPrinterModalHide}
            getCurrData={getCurrData}
            outletName={outletName}
            registerName={registerName}
            data={data}
            XZData={getOpenCloseData}
            printExtraData={printExtraData}
            callBackDefault={callBackDefault}
            decimal={decimal}
            storeInfo={getReduxStoreInfo}
            showRefID={showRefID}
            showSaleTax={showSaleTax}
            showSaleDate={showSaleDate}
            showTotalAmount={showTotalAmount}
            showTotalTax={showTotalTax}
          /> */}
          <TabletPrinters
            visible={showPrinters}
            hide={onPrinterModalHide}
            getCurrData={getCurrData}
            outletName={outletName}
            registerName={registerName}
            data={data}
            XZData={getOpenCloseData}
            printExtraData={printExtraData}
            callBackDefault={callBackDefault}
            decimal={decimal}
            storeInfo={getReduxStoreInfo}
            showRefID={showRefID}
            showSaleTax={showSaleTax}
            showSaleDate={showSaleDate}
            showTotalAmount={showTotalAmount}
            showTotalTax={showTotalTax}
            templateData={getTemplateData}
            allowDiscountShow={allowDiscountShow}
            allowPrintNote={allowPrintNote}
          />
          <SwitchLayouts />
        </>
      )}
    </div>
  )
}

export default InfoToPrint
